import { render, staticRenderFns } from "./IDMLLayersTree.vue?vue&type=template&id=0facaa56&scoped=true"
import script from "./IDMLLayersTree.vue?vue&type=script&lang=js"
export * from "./IDMLLayersTree.vue?vue&type=script&lang=js"
import style0 from "./IDMLLayersTree.vue?vue&type=style&index=0&id=0facaa56&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0facaa56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0facaa56')) {
      api.createRecord('0facaa56', component.options)
    } else {
      api.reload('0facaa56', component.options)
    }
    module.hot.accept("./IDMLLayersTree.vue?vue&type=template&id=0facaa56&scoped=true", function () {
      api.rerender('0facaa56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/idml-layers/IDMLLayersTree.vue"
export default component.exports